(function () {
  var STORAGE_KEY = 'mb_wishlist_v1';

  // ---------- Storage ----------
  function readHandles() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  function writeHandles(handles) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(handles)); } catch (e) {}
  }

  function has(handle) { return readHandles().indexOf(String(handle)) !== -1; }

  function add(handle) {
    var handles = readHandles();
    handle = String(handle);
    if (handles.indexOf(handle) === -1) {
      handles.push(handle);
      writeHandles(handles);
      notify();
    }
  }

  function remove(handle) {
    handle = String(handle);
    writeHandles(readHandles().filter(function (h) { return h !== handle; }));
    notify();
  }

  function toggle(handle) {
    handle = String(handle);
    if (has(handle)) { remove(handle); return false; }
    add(handle);
    return true;
  }

  function notify() {
    document.dispatchEvent(new CustomEvent('mb:wishlist:change', { detail: { handles: readHandles() } }));
  }

  window.mbWishlist = { has: has, add: add, remove: remove, toggle: toggle, readHandles: readHandles };

  // ---------- Money formatting (Shopify's standard money.js pattern) ----------
  function formatMoney(cents, format) {
    var formatString = format || window.themeMoneyFormat || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision, thousands, decimalSep) {
      precision = isNaN(precision) ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimalSep = decimalSep == null ? '.' : decimalSep;
      if (isNaN(number)) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimalSep + parts[1] : '';
      return dollars + frac;
    }

    var match = formatString.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return match ? formatString.replace(placeholderRegex, value) : ('$' + value);
  }

  function escapeHtml(str) {
    return (str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sizedImg(url, width) {
    if (!url) return '';
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'width=' + width;
  }

  // ---------- Button + badge sync ----------
  function syncButtons() {
    var handles = readHandles();
    document.querySelectorAll('[data-mb-wish-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      var saved = handles.indexOf(handle) !== -1;
      btn.classList.toggle('is-active', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
  }

  function updateBadge() {
    var count = readHandles().length;
    document.querySelectorAll('[data-mb-hdr-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    var openBtn = document.querySelector('[data-mb-hdr-open-wishlist]');
    if (openBtn) openBtn.classList.toggle('is-active', count > 0);
  }

  // ---------- Drawer ----------
  function getRoot() { return document.querySelector('[data-mb-wishd-root]'); }

  function openDrawer() {
    var root = getRoot();
    if (!root) return;
    root.classList.add('is-open');
    document.body.classList.add('mb-wishd-lock');
    var panel = root.querySelector('.mb-wishd__panel');
    if (panel) panel.focus();
  }

  function closeDrawer() {
    var root = getRoot();
    if (!root) return;
    root.classList.remove('is-open');
    document.body.classList.remove('mb-wishd-lock');
  }

  function renderItem(product) {
    var variant = product.variants && product.variants[0];
    var imgUrl = product.featured_image || (product.images && product.images[0]) || '';
    var imgTag = imgUrl ? '<img src="' + sizedImg(imgUrl, 160) + '" alt="" loading="lazy" width="48" height="48">' : '';
    var price = variant ? formatMoney(variant.price) : '';
    var available = !!(variant && variant.available);
    var variantId = variant ? variant.id : '';

    return (
      '<div class="mb-wishd__item" data-mb-wishd-line data-product-handle="' + product.handle + '">' +
        '<a href="' + product.url + '" class="mb-wishd__item-cover">' + imgTag + '</a>' +
        '<div class="mb-wishd__item-info">' +
          '<a href="' + product.url + '" class="mb-wishd__item-title">' + escapeHtml(product.title) + '</a>' +
          '<div class="mb-wishd__item-price">' + price + '</div>' +
          '<div class="mb-wishd__item-acts">' +
            '<button type="button" class="mb-wishd__add" data-mb-wishd-add data-variant-id="' + variantId + '"' + (available ? '' : ' disabled') + '>' +
              (available ? 'Add to cart' : 'Out of stock') +
            '</button>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="mb-wishd__remove" data-mb-wishd-remove aria-label="Remove ' + escapeHtml(product.title) + '">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
        '</button>' +
      '</div>'
    );
  }

  function refreshDrawerContent() {
    var root = getRoot();
    if (!root) return Promise.resolve();
    var itemsEl = root.querySelector('[data-mb-wishd-items]');
    var emptyEl = root.querySelector('[data-mb-wishd-empty]');
    var footerEl = root.querySelector('[data-mb-wishd-footer]');
    var handles = readHandles();

    if (!handles.length) {
      if (itemsEl) { itemsEl.hidden = true; itemsEl.innerHTML = ''; }
      if (emptyEl) emptyEl.hidden = false;
      if (footerEl) footerEl.hidden = true;
      return Promise.resolve();
    }

    if (emptyEl) emptyEl.hidden = true;

    return Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (res) { return res.ok ? res.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      var valid = products.filter(Boolean);
      // A saved handle whose product was deleted/unpublished silently drops out.
      if (itemsEl) {
        itemsEl.innerHTML = valid.map(renderItem).join('');
        itemsEl.hidden = false;
      }
      if (footerEl) footerEl.hidden = false;
    });
  }

  // ---------- Wishlist PAGE (separate from the drawer — reuses the REAL
  // product card via the Section Rendering API instead of a JS-only
  // reconstruction, so metafields/rating/add-to-cart stay identical to
  // every other card on the site) ----------
  function getPageGrid() { return document.querySelector('[data-mb-wish-page-grid]'); }

  function refreshWishlistPage() {
    var grid = getPageGrid();
    if (!grid) return Promise.resolve();

    var emptyEl = document.querySelector('[data-mb-wish-page-empty]');
    var countEl = document.querySelector('[data-mb-wish-page-count]');
    var handles = readHandles();

    if (countEl) {
      countEl.textContent = handles.length + (handles.length === 1 ? ' saved' : ' saved');
      countEl.hidden = handles.length === 0;
    }

    if (!handles.length) {
      grid.hidden = true;
      grid.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return Promise.resolve();
    }

    if (emptyEl) emptyEl.hidden = true;

    return Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '?section_id=mecca-wishlist-card-proxy')
          .then(function (res) { return res.ok ? res.text() : ''; })
          .catch(function () { return ''; });
      })
    ).then(function (htmlList) {
      grid.innerHTML = htmlList.join('');
      grid.hidden = false;
      syncButtons(); // newly-inserted hearts need their active state applied
    });
  }

  // ---------- Events ----------
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-mb-hdr-open-wishlist]');
    if (openBtn) {
      e.preventDefault();
      refreshDrawerContent().then(openDrawer);
      return;
    }

    if (e.target.closest('[data-mb-wishd-close]') || e.target.closest('[data-mb-wishd-overlay]')) {
      closeDrawer();
      return;
    }

    var toggleBtn = e.target.closest('[data-mb-wish-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      var handle = toggleBtn.getAttribute('data-product-handle');
      toggle(handle);
      syncButtons();
      updateBadge();
      var root = getRoot();
      if (root && root.classList.contains('is-open')) refreshDrawerContent();
      refreshWishlistPage();
      return;
    }

    var removeBtn = e.target.closest('[data-mb-wishd-remove]');
    if (removeBtn) {
      var line = removeBtn.closest('[data-mb-wishd-line]');
      var h = line && line.getAttribute('data-product-handle');
      if (h) {
        remove(h);
        syncButtons();
        updateBadge();
        refreshDrawerContent();
        refreshWishlistPage();
      }
      return;
    }

    var addBtn = e.target.closest('[data-mb-wishd-add]');
    if (addBtn) {
      var variantId = addBtn.getAttribute('data-variant-id');
      if (!variantId || addBtn.disabled) return;
      addBtn.disabled = true;
      var originalText = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function () {
          closeDrawer();
          var openCartBtn = document.querySelector('[data-mb-hdr-open-cart]');
          if (openCartBtn) openCartBtn.click();
        })
        .finally(function () {
          addBtn.disabled = false;
          addBtn.textContent = originalText;
        });
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  document.addEventListener('mb:wishlist:change', function () {
    syncButtons();
    updateBadge();
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncButtons();
    updateBadge();
    refreshWishlistPage();
  });
})();
